import React from 'react';
import classnames from 'classnames';
import {Field} from 'formik';
import styles from './styles.module.scss';

const FieldCheckbox = ({
                         fieldId,
                         label = 'הוספת כותרת לקובץ',
                         containerStyles = null,
                         customLabelStyles = null,
                         variant,
                         ...rest
                       }) => {
  switch (variant) {
    case 'slider':
      return (
        <Field
          id={fieldId}
          name={fieldId}
        >
          {({field, form}) => (
            <label className={classnames(styles.sliderContainer, containerStyles)}>
              <input
                type="checkbox"
                className={styles.sliderInput}
                checked={!!field.value}
                {...field}
                {...rest}
                onChange={(e) => {
                  form.setFieldValue(fieldId, e.target.checked); // tell Formik
                  rest.onChange?.(e); // still call your custom onChange (soldShare.onChange)
                }}
              />
              <span className={styles.sliderRound}></span>
              <span className={classnames(styles.slideLabel, customLabelStyles)}>{label}</span>
            </label>
          )}
        </Field>
      )
    case 'field':
    default:
      return (
        <Field
          id={fieldId}
          name={fieldId}
        >
          {({field, meta}) => (
            <label className={classnames(styles.inputContainer, containerStyles)}>
              <div className={styles.checkboxContainer}>
                <input
                  className={classnames(styles.input)}
                  type='checkbox'
                  checked={field.value}
                  {...field}
                  {...rest}
                />
                <div className={classnames(styles.checkbox, {
                  [styles.checked]: field.value,
                  [styles.errorBorder]: meta.error && meta.touched,
                  [styles.disabled]: rest.disabled
                })}
                />
                <div className={classnames(styles.labelContainer, customLabelStyles)}>
                  {label}
                </div>
              </div>
            </label>
          )}
        </Field>
      )
  }
};

export default FieldCheckbox;